import React, { useState } from 'react';
import { Col, Dropdown, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink, Row, TabContent, TabPane,Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

import SimpleBar from "simplebar-react";
import NotificationState from 'Hooks/Notification.state';
const NotificationDropdown = ({notifications=[],onClear}) => {
    const {UpdateNotification} = NotificationState()
    //Dropdown Toggle
    const [isNotificationDropdown, setIsNotificationDropdown] = useState(false);
    const toggleNotificationDropdown = () => {
        setIsNotificationDropdown(!isNotificationDropdown); 
        const ids = notifications.map((item)=>item._id)
       
        setTimeout(()=>{
            UpdateNotification(ids)
        },1000)
    };

    //Tab 
    const [activeTab, setActiveTab] = useState('1');
    const toggleTab = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };

    function timeAgo(dateString) {
        const now = new Date();
        const date = new Date(dateString);
        const differenceInSeconds = Math.floor((now - date) / 1000);
    
        if (isNaN(differenceInSeconds) || differenceInSeconds < 0) {
            return "0 Seconds ago";
        } else if (differenceInSeconds < 60) {
            return `${differenceInSeconds} Seconds ago`;
        } else if (differenceInSeconds < 3600) {
            const minutes = Math.floor(differenceInSeconds / 60);
            return `${minutes} ${minutes === 1 ? 'minute' : 'Minutes'} ago`;
        } else if (differenceInSeconds < 86400) {
            const hours = Math.floor(differenceInSeconds / 3600);
            return `${hours} ${hours === 1 ? 'hour' : 'Hours'} ago`;
        } else {
            const days = Math.floor(differenceInSeconds / 86400);
            return `${days} ${days === 1 ? 'day' : 'Days'} ago`;
        }
    }

    return (
        <React.Fragment>
            <Dropdown  isOpen={isNotificationDropdown} toggle={toggleNotificationDropdown} className="topbar-head-dropdown ms-1 header-item">
                <DropdownToggle type="button" tag="button" className=" btn-icon btn-topbar btn-ghost-secondary rounded-circle">
                    <i className='las la-bell fs-22'></i>
                    <span
                        className="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger">{notifications.length}<span
                            className="visually-hidden">unread messages</span></span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
                    <div className="dropdown-head  bg-pattern rounded-top">
                        <div className="p-3">
                            <Row className="align-items-center">
                                <Col>
                                    <h6 className="m-0 fs-16 fw-semibold text-white"> Notifications </h6>
                                </Col>
                                <div className="col-auto dropdown-tabs">
                                    <span className="badge bg-light-subtle text-body fs-13"> {notifications.length} New</span>
                                </div>
                            </Row>
                        </div>

                        <div className="px-2 pt-2">
                            <Nav className="nav-tabs dropdown-tabs nav-tabs-custom">
                                <NavItem>
                                    <NavLink
                                        href="#"
                                        className={classnames({ active: activeTab === '1' })}
                                        onClick={() => { toggleTab('1'); }}
                                    >
                                        All ({notifications.length})
                                    </NavLink>
                                </NavItem>
                               
                             
                            </Nav>
                        </div>

                    </div>

                    <TabContent activeTab={activeTab} style={{position:"relative"}} >
                        <TabPane tabId="1" className="py-2 ps-2">
                            <SimpleBar style={{ maxHeight: "300px" }} className="pe-2">
                              
                                {notifications.map((notification, index) => (
                                      <div key={index} className="text-reset notification-item d-block dropdown-item position-relative">
                                      <div className="d-flex">
                                          <img src="/driver_forms/assets/images/user-dummy-img.jpg"
                                              className="me-3 rounded-circle avatar-xs" alt="user-pic" />
                                          <div className="flex-grow-1">
                                              <Link to="#" className="stretched-link">
                                                <h6 className="mt-0 mb-1 fs-13 fw-semibold">
                                                  {notification?.name || (notification?.route ? String(notification.route).replace(/-/g, " ") : "Notification")}
                                                </h6>
                                              </Link>
                                              <div className="fs-13 text-muted">
                                                  <p className="mb-1">{notification.message}</p>
                                              </div>
                                              <p className="mb-0 fs-11 fw-medium  text-muted">
                                                  <span><i className="mdi mdi-clock-outline"></i> {timeAgo(notification.created_at)}</span>
                                              </p>
                                          </div>
                                         
                                      </div>
                                  </div>
                                ))}
                              

            

                                 {/* <div className="my-3 text-center">
                                     <button type="button" className="btn btn-soft-success waves-effect waves-light">View
                                         All Notifications <i className="ri-arrow-right-line align-middle"></i></button>
                                 </div> */}
                               
                            </SimpleBar>
                           
                        </TabPane>

                    </TabContent>
                    {notifications.length>0 &&(
                         <div style={{color:"green",cursor:"pointer",textAlign:"end",padding:10}} onClick={onClear} >Clear All</div>
                         )}
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default NotificationDropdown;